export const fetchOverDataActionType = {
  START_FETCHING_OVERVIEW_DATA: 'START_FETCHING_OVERVIEW_DATA',
  SUCCESS_FETCHING_OVERVIEW_DATA: 'SUCCESS_FETCHING_OVERVIEW_DATA',
  FAILURE_FETCHING_OVERVIEW_DATA: 'FAILURE_FETCHING_OVERVIEW_DATA',
  CLEAR_OVERVIEW_DATA: 'CLEAR_OVERVIEW_DATA'
};

export const FETCH_OVERVIEW_DATA_PAGE_TYPE = 'medallia';
export const FETCH_OVERVIEW_DATA_CAMPAIGN = 'overview_page_test';

export const FETCH_CLEANLINESS_DIAL_TOPIC_CAMPAIGN = 'cleanliness_dial_topic_page';
export const FETCH_FRIENDLINESS_DIAL_TOPIC_CAMPAIGN = 'friendliness_dial_topic_page';
export const FETCH_ONLINE_REVIEW_RATING_DIAL_TOPIC_CAMPAIGN = 'online_review_rating_dial_topic_page';
export const FETCH_NPS_DIAL_TOPIC_CAMPAIGN = 'nps_dial_topic_page';
export const FETCH_OVERALL_SURVEY_DIAL_TOPIC_CAMPAIGN = 'overall_survey_dial_topic_page';
